import { applyMiddleware, compose, combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';

import thunk from 'redux-thunk';

import examReducer from './reducers/exam';
import rankingReducer from './reducers/ranking';
import dashboardStatsReducer from './reducers/dashboardStats';
import paginationReducer from './reducers/pagination';
import themeReducer from './reducers/theme';
import userReducer from './reducers/user';
import profileReducer from './reducers/profile';

import filteringReducer from './reducers/filtering';
import questionReducer from './reducers/question';

import { api } from '../api/service';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = {
	reducer: {
		[api.reducerPath]: api.reducer,
		exam: examReducer,
		rank: rankingReducer,
		filtering: filteringReducer,
		dashboard: dashboardStatsReducer,
		pagination: paginationReducer,
		question: questionReducer,
		theme: themeReducer,
		user: userReducer,
		profile: profileReducer
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware)
};

const store = configureStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

export default store;
